import { ColorEnum } from '@/constants/color'
import { animationDurationMs } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/constants'
import {
    Easing,
    interpolateColor,
    useAnimatedReaction,
    useAnimatedStyle,
    useSharedValue,
    withTiming,
} from 'react-native-reanimated'

interface Colors {
    unselected: ColorEnum
    selected: ColorEnum
}

export const useAnimatedTextColorStyle = (selected: boolean, colors: Colors) => {
    const progress = useSharedValue(0)

    useAnimatedReaction(
        () => selected,
        () => {
            progress.value = withTiming(selected ? 1 : 0, {
                duration: animationDurationMs,
                easing: Easing.out(Easing.linear),
            })
        }
    )

    return useAnimatedStyle(() => {
        const color = interpolateColor(progress.value, [0, 1], [colors.unselected, colors.selected])

        return { color }
    })
}
